import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { Alert, Spinner, Card, ListGroup, Badge, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UserRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRequests = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const q = query(
          collection(db, "requests"), 
          where("userId", "==", user.uid)
        );
        
        const querySnapshot = await getDocs(q);
        const requestsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setRequests(requestsData);
      } catch (error) {
        console.error("Error al cargar solicitudes:", error);
        setAlert({
          show: true,
          message: "Error al cargar tus solicitudes. Intente nuevamente más tarde.",
          variant: "danger"
        });
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, [user]);

  const getStatusBadge = (status) => {
    switch(status.toLowerCase()) {
      case 'pending': return 'warning';
      case 'approved': return 'success';
      case 'rejected': return 'danger';
      case 'completed': return 'primary';
      default: return 'secondary';
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = dateString?.toDate ? dateString.toDate() : new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return 'Fecha no disponible';
    }
  };

  const handleViewDetails = (requestId) => {
    navigate(`/solicitudes/${requestId}`);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Mis Solicitudes</h2>
      
      {alert.show && (
        <Alert variant={alert.variant} onClose={() => setAlert({...alert, show: false})} dismissible>
          {alert.message}
        </Alert>
      )}

      {requests.length === 0 ? (
        <Card>
          <Card.Body className="text-center">
            <Card.Text>No has realizado ninguna solicitud aún.</Card.Text>
            <Button 
              variant="primary" 
              onClick={() => navigate('/request-medication')}
            >
              Solicitar un medicamento
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <ListGroup>
          {requests.map((request) => (
            <ListGroup.Item key={request.id} className="mb-3">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5>{request.medicationName}</h5>
                  <p className="mb-1">
                    <strong>Estado:</strong> 
                    <Badge bg={getStatusBadge(request.status)} className="ms-2">
                      {request.status.toUpperCase()}
                    </Badge>
                  </p>
                  <p className="mb-1">
                    <strong>Donante:</strong> {request.donorName || request.donorEmail || 'No especificado'}
                  </p>
                  <p className="mb-1">
                    <strong>Fecha:</strong> {formatDate(request.createdAt)}
                  </p>
                  <p className="mb-1">
                    <strong>Cantidad:</strong> {request.quantity}
                  </p>
                </div>
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  onClick={() => handleViewDetails(request.id)}
                >
                  Ver detalles
                </Button>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </div>
  );
};

export default UserRequests;
